/**
 * Shared formatting for "list"-style EMR sections (Complaints, Observations, Advice,
 * Investigations, Therapy, Assessments, …). Reads the per-section style overrides
 * (displayFormat / capitalizeName / nameBold + keyColor) and the prescription-wide
 * list separator, and renders the item labels as an inline separator-joined list or as
 * bullet points. All flags default OFF so existing templates render unchanged.
 */
export function getSectionListFormatConfig(styleOverrides, bodyListSeparator, { defaultBullet = false } = {}) {
  const other = styleOverrides?.otherStyles || {}
  // Respect an explicit displayFormat; otherwise fall back to the section's own default
  // (e.g. Instructions renders as bullets) so existing templates are unchanged.
  const isBullet = other.displayFormat
    ? other.displayFormat === 'bullet'
    : defaultBullet
  return {
    isBullet,
    capitalize: other.capitalizeName === 'true',
    bold: other.nameBold === 'true',
    keyColor: styleOverrides?.keyColor || undefined,
    valueColor: styleOverrides?.color || undefined,
    separator: bodyListSeparator || ', ',
  }
}

export function applyNameCase(text, capitalize) {
  return capitalize ? String(text ?? '').toUpperCase() : text
}

/**
 * Render an array of {label} items per the section format config.
 * Returns a React node (inline spans or a <ul> of bullets).
 */
export function renderSectionLabelList(items, cfg) {
  const labels = (items || []).map((it) => it?.label).filter((l) => l != null && l !== '')
  if (labels.length === 0) return null
  const nameStyle = {
    fontWeight: cfg.bold ? 700 : 'inherit',
    color: cfg.keyColor || 'inherit',
  }

  if (cfg.isBullet) {
    return (
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {labels.map((label, i) => (
          <li key={i} style={nameStyle}>
            {applyNameCase(label, cfg.capitalize)}
          </li>
        ))}
      </ul>
    )
  }

  return labels.map((label, i) => (
    <span key={i}>
      <span style={nameStyle}>{applyNameCase(label, cfg.capitalize)}</span>
      {i < labels.length - 1 ? cfg.separator : ''}
    </span>
  ))
}
